import axios from "axios";
import { useMutation, useQueryClient } from "react-query";
import { QUERY_KEYS } from "../constants/reactQueryKeyConsts";

export const  useUpdateDropdownOptions =({report}) => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: async ({body,config}) => {
        //console.log("config is", config);
        return axios.post(`${process.env.REACT_APP_API_URI}ConfigScreen`, body, config);
      },
      onSuccess: () => {
           queryClient.invalidateQueries([QUERY_KEYS.CONFIGURABLE,report])
      }
    });
  }